module.exports = __webpack_public_path__ + "img/partner-1.8cbeb2c5.8cbeb2c5.jpg";